import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { layout } from '@prisjakt/ui-base';

import { OutlinedButton } from '@prisjakt/ui/button/variants';
import { Column, Row } from '@prisjakt/ui/list/variants';

export const MenuButton = styled.span`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: right;
  color: #fff;

  &:focus {
    outline: none;
  }

  &:hover {
    color: #fff;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: ${layout.measurements.spacing050};
`;

export const AccountButton = styled(OutlinedButton)`
  &:not(:last-child) {
    margin-bottom: ${layout.measurements.spacing050};
  }
`;

export const SignupLink = styled(Link)`
  color: ${p => p.theme.colors.maybeBlue700};
  text-decoration: underline;

  &:hover {
    color: ${p => p.theme.colors.maybeBlue500};
  }
`;

export const MenuItemLink = styled(Link)`
  display: block;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const ProfileLinks = styled(Column)`
  padding: ${layout.measurements.spacing100};
`;

export const AnalyticsWrapper = styled(Row)`
  align-items: center;

  svg {
    fill: ${p => p.theme.colors.maybeBlue700};
  }
`;
